// Module
var code = "<div class=\"nlgPortlet portlet\" ng-transclude></div>";
// Exports
module.exports = code;